import { computePositionChangesFromSessions } from '../../shared/leaderboardShared';

const DEMO_DUOS = [
    ['Zmatix', 'Kaoz'], ['Vortex', 'Nyxie'], ['Aqualix_FN', 'Sh4dow'], ['Tryhard Tom', 'Bugha Jr'],
    ['Elyon', 'Rekkz'], ['Pandaa', 'Mistik'], ['Skyz', 'Wexo'], ['xXDarkSasukeXx', 'LeMeilleurDuMonde'],
    ['Kenzo', 'Lyra'], ['Nox', 'Fury'], ['Oxy', 'Pulsar'], ['Hydra', 'Kami'],
    ['Saiko', 'Vela'], ['Blitz', 'Orion'], ['Neko', 'Raze'], ['Mako', 'Tiz'],
    ['Jinx', 'Ember'], ['Sora', 'Kyro'], ['Volt', 'Ash'], ['Rune', 'Pixel'],
    ['Zephyr', 'Milo'], ['Kairo', 'Lumi'], ['Drako', 'Yuna'], ['Spectra', 'Bolt'],
    ['Riven', 'Echo'], ['Talon', 'Nova'], ['Ghost', 'Iris'], ['Vex', 'Comet'],
    ['Astra', 'Fenrir'], ['Pyro', 'Glace'], ['Onyx', 'Sable'], ['Kira', 'Storm'],
];
const GAMES_MIN = 2;
const GAMES_CYCLE = 5;
const PHASES = 5;
const ALIVE_RATIOS = [0, 0.75, 0.45, 0.2, 0.06];

function createRandom(seed) {
    let state = seed;
    return () => {
        state = (state * 1664525 + 1013904223) % 4294967296;
        return state / 4294967296;
    };
}

function placementPoints(place) {
    if (place === 1) return 25;
    if (place <= 5) return 15;
    if (place <= 15) return 8;
    if (place <= 25) return 3;
    return 0;
}

let demoTick = 0;

export function fetchDemoLeaderboardData() {
    demoTick += 1;
    const phase = demoTick % PHASES;
    const finishedGames = GAMES_MIN + (Math.floor(demoTick / PHASES) % GAMES_CYCLE);
    const rows = [];
    const teamDetails = {};

    DEMO_DUOS.forEach((names, teamIndex) => {
        const members = names.map((name, memberIndex) => ({
            id: `demo-${teamIndex}-${memberIndex}`,
            name,
            ingame_name: name,
        }));
        const sessions = Array.from({ length: finishedGames }, (_, gameIndex) => {
            const random = createRandom(teamIndex * 7919 + gameIndex * 104729 + 17);
            const place = 1 + Math.floor(random() * random() * 50);
            const kills = Math.floor(random() * 9);
            return { place, kills, points: placementPoints(place) + kills * 2 };
        });
        const aliveRoll = createRandom(teamIndex * 3571 + finishedGames * 613 + 5)();

        const teamname = [...names].sort((a, b) => a.localeCompare(b)).join(' - ');
        const points = sessions.reduce((sum, session) => sum + session.points, 0);
        rows.push({
            teamname,
            elims: sessions.reduce((sum, session) => sum + session.kills, 0),
            wins: sessions.filter((session) => session.place === 1).length,
            avg_place: sessions.reduce((sum, session) => sum + session.place, 0) / finishedGames,
            games: finishedGames,
            points,
            place: 0,
            alive: aliveRoll < ALIVE_RATIOS[phase],
            memberData: [],
            sessionsForIndicators: sessions,
        });
        teamDetails[teamname] = { members, sessions, teamData: { points } };
    });

    rows.sort((a, b) => (b.points - a.points) || (b.wins - a.wins) || (b.elims - a.elims) || a.teamname.localeCompare(b.teamname));
    rows.forEach((row, index) => {
        row.place = index + 1;
        teamDetails[row.teamname].teamData.place = row.place;
    });
    const allDead = rows.every((row) => !row.alive);
    const positionChanges = allDead ? computePositionChangesFromSessions(rows) : {};

    return {
        leaderboard: rows.map((row) => ({ ...row, positionChange: allDead ? positionChanges[row.teamname] ?? null : null })),
        teamDetails,
        totalPages: 1,
        showPositionIndicators: allDead,
    };
}
